// extracted by mini-css-extract-plugin
export default {"title":"AddMember_title__JYEAg","boxForm":"AddMember_boxForm__-6MRS","form":"AddMember_form__QnMBA"};